<template>
    <el-image lazy fit="cover" :class="className" :src="resolvedThumbUrl" :preview-src-list="list" @load="loadSuccess">
        <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
        </div>
    </el-image>
</template>
<script>

export default {
    data() {
        return {
            list: [],
            timer: ''
        }
    },
    props: {
        msgInfo: {
            type: Object,
            required: true
        },
        className: {
            type: String,
            default: '',
        },
        chat: {
            type: Object,
        }
    },
    methods: {
        // image进行懒加载，如果当前图片出现在视图中且加载成功的情况下判断是否有原图，没有则去接口查询
        sameMessage(left, right) {
            if (!left || !right) {
                return false;
            }
            if (left === right) {
                return true;
            }
            const leftKey = left.id || left.tmpId;
            const rightKey = right.id || right.tmpId;
            return leftKey != null && leftKey !== '' && String(leftKey) === String(rightKey);
        },
        ownerChat(msg) {
            if (!msg) {
                return null;
            }
            if (msg.groupId) {
                return { type: 'GROUP', targetId: msg.groupId };
            }
            const myId = this.$store.state.userStore.userInfo && this.$store.state.userStore.userInfo.id;
            if (myId == null || myId === '') {
                return this.chat || null;
            }
            let targetId = null;
            if (String(msg.sendId) === String(myId)) {
                targetId = msg.recvId;
            } else if (msg.recvId == null || msg.recvId === '' || String(msg.recvId) === String(myId)) {
                targetId = msg.sendId;
            }
            if (targetId == null || targetId === '') {
                return null;
            }
            return { type: 'PRIVATE', targetId };
        },
        loadSuccess() {
            const content = this.content;
            const msgInfo = this.msgInfo;
            if (!content || content.originalFinished || !content.imageId) {
                this.list = [this.$mediaUrl((content && (content.originUrl || content.thumbUrl)) || '')];
                return;
            }
            this.$http({
                url: `/image/getOriginUrl?imageId=${content.imageId}`,
                method: 'get'
            }).then(res => {
                const alive = !this._isDestroyed && !this._isBeingDestroyed && this.sameMessage(this.msgInfo, msgInfo);
                if (!res.originalFinished) {
                    if (!alive) {
                        return;
                    }
                    // 如果仍然未传成功，2s后再次去更新直到获取到为止
                    this.timer = setTimeout(() => {
                        this.loadSuccess();
                    }, 2000)
                    return;
                }
                if (alive) {
                    this.list = [this.$mediaUrl(res.originUrl || res.thumbUrl)];
                }
                const chatInfo = this.ownerChat(msgInfo);
                if (!chatInfo) {
                    return;
                }
                // 只回写原消息所在会话里已经存在的那条，避免切会话后插进当前窗口
                this.$store.commit("updateMessage", [{
                    ...msgInfo,
                    content: JSON.stringify({
                        ...content,
                        originUrl: res.originUrl,
                        originalFinished: true
                    })
                }, chatInfo]);
            })
        },
    },
    mounted() {
        this.list = [this.$mediaUrl(this.content.originUrl || this.content.thumbUrl)];
    },
    computed: {
        content() {
            return JSON.parse(this.msgInfo.content);
        },
        resolvedThumbUrl() {
            return this.$mediaUrl(this.content.thumbUrl || this.content.originUrl);
        }
    },
    destroyed() {
        clearTimeout(this.timer)
    }
}
</script>

<style scoped lang="scss"></style>